import { useTransition } from 'react'

import { useNavigate } from '@tanstack/react-router'

import { useCurrentTabLink } from '@/hooks/use-current-tablink'

import { TabLinkItem, TabsLink } from '@/components/common/tab-link'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/components/ui/select'

type Tabs =
	| 'overview'
	| 'case-management'
	| 'policy-management'
	| 'automation-settings'

export const AirTabs = () => {
	const navigate = useNavigate()
	const currentTab = useCurrentTabLink()

	const [_isPending, startTransition] = useTransition()

	const handleTabChange = (tab: Tabs) => {
		// Navigate with startTransition
		startTransition(() => {
			navigate({
				to: `/air/${tab}`,
			})
		})
	}

	return (
		<>
			{/* Desktop */}
			<TabsLink className="hidden h-10 sm:inline-flex">
				<TabLinkItem to="/air/overview">Overview</TabLinkItem>
				<TabLinkItem to="/air/case-management">Case Management</TabLinkItem>
				<TabLinkItem to="/air/policy-management">Policy Management</TabLinkItem>
				<TabLinkItem to="/air/automation-settings">
					Automation Settings
				</TabLinkItem>
			</TabsLink>

			{/* Mobile */}
			<div className="flex sm:hidden">
				{/*  We pass 'overview' as default value to keep the Select controlled */}
				<Select
					value={currentTab || 'overview'}
					onValueChange={(value) => handleTabChange(value as Tabs)}
				>
					<SelectTrigger>
						<SelectValue data-placeholder="Select Tab" />
					</SelectTrigger>
					<SelectContent>
						<SelectItem value="overview">Overview</SelectItem>
						<SelectItem value="case-management">Case Management</SelectItem>
						<SelectItem value="policy-management">Policy Management</SelectItem>
						<SelectItem value="automation-settings">
							Automation Settings
						</SelectItem>
					</SelectContent>
				</Select>
			</div>
		</>
	)
}
